.subscriptionCardContainer {
  padding: var(--cxy-spacing-6) var(--cxy-spacing-4);
}
@media (min-width: 600px) {
  .subscriptionCardContainer {
    padding: var(--cxy-spacing-7) var(--cxy-spacing-8);
  }
}
@media (min-width: 1281px) {
  .subscriptionCardContainer {
    padding: var(--cxy-spacing-7) 100px;
  }
}
.subscriptionCardContainer .tabsList {
  margin-block-end: var(--cxy-spacing-7);
}

.textContainer {
  padding-block-start: var(--cxy-spacing-6);
}
